export default __webpack_public_path__ + "static/media/Desktop-Model3.30651f79.jpeg";